var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32213_208649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21873 12.2188C9.21873 10.7758 10.3898 9.60468 11.8328 9.60468C13.2758 9.60468 14.4469 10.7758 14.4469 12.2188C14.4469 13.6617 13.2758 14.8328 11.8328 14.8328C10.3898 14.8537 9.21873 13.6617 9.21873 12.2188ZM11.8328 1.21875C6.68831 1.21875 2.38032 4.73206 1.1674 9.50012C1.1674 9.54194 1.14648 9.56286 1.14648 9.60468C1.14648 9.89746 1.37652 10.1275 1.6693 10.1275H6.10276C6.31188 10.1275 6.5001 10.002 6.58375 9.81381C7.5039 7.82711 9.49059 6.44689 11.8328 6.44689C15.0115 6.44689 17.6047 9.04004 17.6047 12.2188C17.6047 15.3975 15.0115 17.9906 11.8328 17.9906C9.5115 17.9906 7.5039 16.6104 6.58375 14.6237C6.5001 14.4355 6.31188 14.31 6.10276 14.31H1.6693C1.37652 14.31 1.14648 14.54 1.14648 14.8328C1.14648 14.8746 1.14648 14.8956 1.1674 14.9374C2.38032 19.7054 6.68831 23.2188 11.8328 23.2188C17.9183 23.2188 22.8537 18.2834 22.8537 12.1978C22.8537 6.1332 17.9183 1.21875 11.8328 1.21875Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32213_208649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7072,
    height: 22,
    fill: "white",
    transform: "translate(1.14648 1.21875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCi);
export default __webpack_public_path__ + "static/media/CircleCI.61e0760f30cfe2ba4b6ca2e2626b8bca.svg";
export { ForwardRef as ReactComponent };